// #584 Ein Portalzugang für mehrere Eigentümer-Datensätze (z. B. Privatperson + GmbH).
// Verknüpft wird über eigentuemer.profile_id; das Portal liest alle aktiven Datensätze des Logins.
import { eigentuemerAnzeigename, type EigentuemerNameFelder } from './anzeige';

export interface VerbundEigentuemer extends EigentuemerNameFelder { id: string; profile_id: string | null }
export interface VerbundProfil { id: string; email: string | null; status: string | null; role: string | null }

/** Ein bestehender Zugang, mit dem dieser Datensatz verknüpft werden kann. */
export interface ZugangKandidat {
  profilId: string;
  email: string;
  status: string | null;
  /** Datensätze, die schon an diesem Zugang hängen */
  namen: string[];
  /** gleiche E-Mail wie der Datensatz → als Vorschlag zuerst */
  gleicheEmail: boolean;
}

export interface PortalVerbund {
  /** Zugang dieses Datensatzes (eigentuemer.profile_id) */
  profilId: string | null;
  /** weitere Datensätze am selben Zugang */
  andere: { id: string; name: string }[];
  /** bestehende Zugänge zum Verknüpfen (nur wenn noch kein eigener Zugang) */
  kandidaten: ZugangKandidat[];
}

const klein = (s: string | null | undefined) => (s ?? '').trim().toLowerCase();

export function baueVerbund(p: {
  eigId: string;
  profilId: string | null;
  email: string;
  /** Datensätze mit gesetzter profile_id (außer diesem) */
  verknuepfte: readonly VerbundEigentuemer[];
  /** Profile der Rolle eigentuemer: die verknüpften und die mit gleicher E-Mail */
  profile: readonly VerbundProfil[];
}): PortalVerbund {
  const andere = p.profilId
    ? p.verknuepfte.filter((e) => e.id !== p.eigId && e.profile_id === p.profilId).map((e) => ({ id: e.id, name: eigentuemerAnzeigename(e) }))
    : [];
  if (p.profilId) return { profilId: p.profilId, andere, kandidaten: [] };
  const mail = klein(p.email);
  const kandidaten = p.profile
    .filter((x) => klein(x.role) === 'eigentuemer')
    .map((x): ZugangKandidat => ({
      profilId: x.id,
      email: (x.email ?? '').trim(),
      status: x.status,
      namen: p.verknuepfte.filter((e) => e.id !== p.eigId && e.profile_id === x.id).map((e) => eigentuemerAnzeigename(e)),
      gleicheEmail: !!mail && klein(x.email) === mail,
    }))
    .sort((a, b) => Number(b.gleicheEmail) - Number(a.gleicheEmail) || a.email.localeCompare(b.email, 'de'));
  return { profilId: null, andere, kandidaten };
}

/** Text der Auswahlzeile: „mueller@web.de · Louisa Müller“ */
export function kandidatText(k: ZugangKandidat): string {
  return [k.email || 'ohne E-Mail', k.namen.join(', ')].filter(Boolean).join(' · ');
}
